export const processVideoFile = async (videoFile, chunkSize = 1 * 1024 * 1024) => {
    try {
        if (!(videoFile instanceof File)) {
            throw new Error('The provided input is not a valid File object.');
        }
        const newFileName = 'file.mp4';
        const videoFilePath = URL.createObjectURL(videoFile);
        console.log('Video file path:', videoFilePath);

        const fileSize = videoFile.size;
        console.log('Getting video duration...');

        const videoLength = await getVideoDuration(videoFile); // Updated function
        console.log('Video duration:', videoLength);

        await processFileInChunks(videoFile, chunkSize);
        console.log('Video file processed successfully.');

        const renamedFile = new File([videoFile], newFileName, {
            type: videoFile.type,
            lastModified: videoFile.lastModified,
        });

        // Clean up Blob URL to prevent memory leak
        URL.revokeObjectURL(videoFilePath);

        return { renamedFile, videoFilePath, fileSize, videoLength };
    } catch (error) {
        console.error(`Error processing video file: ${error.message}`);
        throw new Error(`Error processing video file: ${error.message}`);
    }
};

// Function to process the file in chunks using Blob.slice()
const processFileInChunks = async (file, chunkSize) => {
    const totalSize = file.size;
    let offset = 0;

    while (offset < totalSize) {
        const nextOffset = Math.min(offset + chunkSize, totalSize);
        const blobChunk = file.slice(offset, nextOffset);
        await readFileChunk(blobChunk); 

        console.log(`Processed chunk: ${offset} to ${nextOffset}`);
        offset = nextOffset;
    }
};

const readFileChunk = (blobChunk) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => resolve(event.target.result);
        reader.onerror = (error) => {
            console.error('Error reading chunk:', error);
            reject(error);
        };
        reader.readAsArrayBuffer(blobChunk);
    });
};


const getVideoDuration = (file) => 
    new Promise((resolve, reject) => {
        const video = document.createElement('video');
        const url = URL.createObjectURL(file);
        video.preload = 'metadata';
        video.src = url;

        video.onloadedmetadata = () => {
            const durationInSeconds = Math.round(video.duration);
            console.log('Video duration extracted:', durationInSeconds);
            resolve(durationInSeconds);
            URL.revokeObjectURL(url);
        };

        video.onerror = (error) => {
            console.error('Error loading video metadata:', error);
            reject(new Error('Error loading video metadata. Unsupported or corrupt video file.'));
        };
    });
